<template>
  <v-content class="gb">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="top-container">
          <v-card flat :loading="status === 'loading'"
                  class="fill-width table_theme card-theme custom-container"
          >
            <v-row>
              <div
                  class="icon-modal icon-modal-mobile table-cell alert-sidebar"
              >
                <v-layout class="align-center">
                  <v-flex>
                    <img
                        :src="require('@/assets/img/message.svg')"
                        alt
                        style="position: relative;top: 320px;left: 20%;"
                    />
                  </v-flex>
                </v-layout>
              </div>
              <v-col class="table-cell modal-content modal-content-push">
                <div class="content_cont_modal">
                  <v-form class="pt-1 pb-0" autocomplete="off">
                    <ValidationObserver ref="validator" v-slot="{}">
                      <v-row>
                        <v-col
                            cols="9"
                            class="content_push_notificatin"
                            style="position: relative;top: -2px;left: 3px;"
                        >
                          <div class="d-flex justify-space-between">
                            <h6 class="title_custom mb-5">
                              Push Notifications
                              Message
                            </h6>
                          </div>
                          <p class="mb-2" style="position: relative;left: 3px;top: 1px;">
                            <label class="label">Send to:</label>
                          </p>
                          <p class="" style="margin-bottom: 0px">
                            <span class="title_text">{{ total_contacts }} total contacts · {{ receptorsWithDevicesCount }} with registered devices</span>
                          </p>
                          <div class="d-flex justify-space-between" style="height: 40px">
                            <v-col
                                cols="12"
                                sm="4"
                                md="4"
                            >
                              <v-checkbox
                                  v-model="vendors"
                                  class="checkbox_options"
                                  :label="`Vendors`"
                                  @change="check_vendors()"
                              ></v-checkbox>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="4"
                                md="4"
                            >
                              <v-checkbox
                                  v-model="agents"
                                  :label="`Agents`"
                                  class="checkbox_options"
                                  @change="check_agents()"
                              ></v-checkbox>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="4"
                                md="4"
                            >
                              <v-checkbox
                                  v-model="clients"
                                  :label="`Homeowners`"
                                  class="checkbox_options"
                                  @change="check_clients()"
                              ></v-checkbox>
                            </v-col>
                          </div>
                          <p class="mb-2">
                          </p>

                          <div class="d-flex justify-space-between">
                            <v-col
                                cols="12"
                                sm="4"
                                md="4"
                            >

                              <v-autocomplete
                                  :items="vendors_list"
                                  v-model="selected_vendors"
                                  item-text="name"
                                  item-value="owner_id"
                                  type="text"
                                  hint="Vendors"
                                  :multiple="true"
                                  :disabled="status === 'loading'"
                                  :readonly="status === 'loading'"
                                  @change="click_select()"
                                  :menu-props="{closeOnContentClick:true}"
                                  persistent-hint
                              >
                                <template v-slot:selection="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <span
                                        v-if="selected_vendors.length !== total_vendors">{{ short_name(item.name) }}</span>
                                    <span v-if="selected_vendors.length === total_vendors">ALL</span>
                                    <span
                                        v-if="index === 0 && selected_vendors.length !== total_vendors && (selected_vendors.length - 1 > 0)"
                                        class="grey--text caption"
                                    >
                                      (+{{ selected_vendors.length - 1 }} others)
                                    </span>
                                    <span
                                        v-if="index === 0 && selected_vendors.length !== total_vendors && (selected_vendors.length - 1 === 0)"
                                        class="grey--text caption"
                                    >
                                    </span>
                                    <span
                                        v-if="index === 0 && selected_vendors.length === total_vendors"
                                        class="grey--text caption"
                                    >
                                    </span>
                                  </v-chip>

                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="4"
                                md="4"
                            >
                              <v-autocomplete
                                  :items="agents_list"
                                  v-model="selected_agents"
                                  item-text="name"
                                  item-value="owner_id"
                                  type="text"
                                  hint="Agents"
                                  :multiple="true"
                                  :disabled="status === 'loading'"
                                  :readonly="status === 'loading'"
                                  @change="click_select()"
                                  :menu-props="{closeOnContentClick:true}"
                                  persistent-hint
                              >
                                <template v-slot:selection="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <span
                                        v-if="selected_agents.length !== total_agents">{{ short_name(item.name) }}</span>
                                    <span v-if="selected_agents.length === total_agents">ALL</span>
                                    <span
                                        v-if="index === 0 && selected_agents.length !== total_agents && (selected_agents.length - 1 > 0)"
                                        class="grey--text caption"
                                    >
                                      (+{{ selected_agents.length - 1 }} others)
                                    </span>
                                    <span
                                        v-if="index === 0 && selected_agents.length !== total_agents && (selected_agents.length - 1 === 0)"
                                        class="grey--text caption"
                                    >
                                    </span>
                                    <span
                                        v-if="index === 0 && selected_agents.length === total_agents"
                                        class="grey--text caption"
                                    >
                                    </span>
                                  </v-chip>

                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="4"
                                md="4"
                            >
                              <v-autocomplete
                                  :items="clients_list"
                                  v-model="selected_clients"
                                  item-text="name"
                                  item-value="owner_id"
                                  type="text"
                                  hint="Homeowners"
                                  :multiple="true"
                                  :filter="returnHeadersAndFilter"
                                  :disabled="status === 'loading'"
                                  :readonly="status === 'loading'"
                                  @change="click_select()"
                                  :menu-props="{closeOnContentClick:true}"
                                  persistent-hint
                              >
                                <template v-slot:selection="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <span
                                        v-if="(selected_clients.length - selected_all_clients.length) !== total_clients">{{ short_name(item.name) }}</span>
                                    <span
                                        v-if="(selected_clients.length - selected_all_clients.length) === total_clients">ALL</span>
                                    <span
                                        v-if="index === 0 && (selected_clients.length - selected_all_clients.length) !== total_clients && ((selected_clients.length - selected_all_clients.length) - 1 > 0)"
                                        class="grey--text caption"
                                    >
                                      (+{{ selected_clients.length - selected_all_clients.length - 1 }} others)
                                    </span>
                                    <span
                                        v-if="index === 0 && (selected_clients.length - selected_all_clients.length) !== total_clients && ((selected_clients.length - selected_all_clients.length) - 1 === 0)"
                                        class="grey--text caption"
                                    >
                                    </span>
                                    <span
                                        v-if="index === 0 && (selected_clients.length - selected_all_clients.length) === total_clients"
                                        class="grey--text caption"
                                    >
                                    </span>
                                  </v-chip>

                                </template>
                              </v-autocomplete>
                            </v-col>


                          </div>

                          <p class="alert-field-container">
                            <ValidationProvider
                                ref="push_title"
                                rules="required"
                                v-slot="{ errors }"
                            >
                              <v-text-field
                                  v-model="title"
                                  class="ui-label change_bord especial_border"
                                  label="Title:"
                                  name="push_title"
                                  type="text"
                                  width="660px"
                                  required
                                  counter
                                  maxlength="32"
                                  hint="Max Character"

                                  :persistent-hint="persistentHint"
                                  :error-messages="errors"
                              ></v-text-field>
                            </ValidationProvider>
                          </p>

                          <div class="mt-6 alert-field-container">
                            <label class="label">Text:</label>
                            <ValidationProvider
                                ref="push_text"
                                rules="required"
                                v-slot="{ errors }"
                            >

                              <v-textarea
                                  v-model="text"
                                  name="push_text"
                                  @keydown.enter.exact.prevent
                                  auto-grow
                                  outlined
                                  rows="2"
                                  row-height="25"
                                  required
                                  style="position: relative;top: 5px;"
                                  id="text_area_push_notification"
                                  class="ui-label custom-textarea change_bord"
                                  counter
                                  :maxlength="max_character"
                                  hint="Max Character"
                                  :persistent-hint="persistentHint"
                                  :error-messages="errors"
                              ></v-textarea>
                            </ValidationProvider>
                          </div>

                          <p
                              class="mt-10"
                              style="margin-bottom: 0px;line-height: 19px !important; color:#061d47 !important; font-weight: 700;font-size:16px !important;position: relative;top: 1px;left: 3px;"
                          >
                            When a user clicks on the push notification, a chat will open with who?
                          </p>
                          <ValidationProvider
                              ref="push_user"
                              rules="required"
                              v-slot="{ errors }"
                          >
                            <v-autocomplete
                                :items="users"
                                v-model="selectedUser"
                                item-text="name"
                                item-value="owner_id"
                                class="label-custom mt-0 pt-0 custom-input-position-text change_bord especial_border custom-select-options"
                                name="push_user"
                                type="text"
                                placeholder="Select one user"
                                style="margin-right: 7px"
                                :multiple="false"
                                :disabled="status === 'loading'"
                                :readonly="status === 'loading'"
                                :error-messages="errors"
                            >
                              <template v-slot:append>
                                <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                              </template>
                            </v-autocomplete>
                            <p style="margin-bottom: 0px;line-height: 19px !important; color:#061d47 !important; font-weight: 700;font-size:12px !important;position: relative;top: 1px;left: 3px;"
                            >
                              *Please note: <br>
                              - The user selected above will not receive the push notification <br>
                              - A homeowner will always open a chat with its own agent, despite if you select a different
                              agent above
                            </p>
                          </ValidationProvider>
                          <!--<v-divider class="mt-11" style="position: relative;top: -10px;"></v-divider>-->

                          <div style="margin-top: 13px;" class="d-flex buttons-option">
                            <v-btn
                                class="btn-azul few "
                                rounded
                                depressed
                                @click="submit"
                                style="width:161px !important;position: relative;left: -16px;font-weight: 700 !important;font-size: 15px;letter-spacing: 0.94px;"
                                :disabled="status === 'loading'"
                                :loading="status === 'loading'"
                            >SEND
                            </v-btn>
                          </div>
                        </v-col>
                        <v-col cols="3" class="imagen_movil"
                               style="position: relative;top: -3px;left: -40px;">
                              <span class="preview_iphone">

                              </span>
                          <span class="title_push">
                                  {{title}}
                              </span>
                          <div class="text_push" id="text_push">
                            <span>
                              {{text}}
                            </span>
                          </div>
                          <img class="d-block" :src="require('@/assets/movil.png')" alt="movil app"/>
                        </v-col>
                      </v-row>
                    </ValidationObserver>
                  </v-form>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <confirm-message-modal
        :show="showConfirmMessageModal"
        :hide="hideConfirmMessageModal"
        :click="clickConfirmMessageModal"
        :cancel="closeConfirmMessageModal"
    ></confirm-message-modal>
    <success-message-modal :show="showSuccessMessageModal" :hide="hideSuccessMessageModal"></success-message-modal>
    <error-message-modal
        :show="showErrorModal"
        :hide="hideErrorModal"
        :body="errorMessage"
    ></error-message-modal>
  </v-content>


</template>

<script>
  import {mapState, mapActions, mapGetters} from "vuex";
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import confirmMessageModal from "./modals/confirm-message";
  import successMessageModal from "./modals/success-message";
  import errorMessageModal from "./modals/error-message";

  var keycode = require('keycode');

  export default {
    props: ["show", "hide", "click"],
    created() {
      this.get_tenant().then((response) => {
        if (response === 'success') {
          this.retrieve_receptors();
          this.retrieve_users();
        }
      });
    },
    data: () => ({
      persistentHint: true,
      title: "",
      text: "",
      vendors: false,
      agents: false,
      clients: false,
      total_contacts: 0,
      image: require("@/assets/logo.svg"),
      selectedUser: null,
      selected_vendors: [],
      selected_agents: [],
      selected_clients: [],
      selected_all_clients: [],
      valid: false,
      max_character: 300,
      showConfirmMessageModal: false,
      showSuccessMessageModal: false,
      showErrorModal: false,
      errorMessage: '',
      lastSummary: null,
      status: ''
    }),
    computed: {
      ...
        mapState({
          vendors_list: state => state.Push_notifications.vendors,
          agents_list: state => state.Push_notifications.agents,
          clients_list: state => state.Push_notifications.clients,
          total_receptors: state => state.Push_notifications.total_receptors,
          total_agents: state => state.Push_notifications.total_agents,
          total_clients: state => state.Push_notifications.total_clients,
          total_vendors: state => state.Push_notifications.total_vendors,
          users: state => state.Push_notifications.users
        }),
      ...
        mapGetters('Push_notifications', ['receptors_with_devices_count']),
      receptorsWithDevicesCount() {
        return this.receptors_with_devices_count;
      }
    }
    ,
    components: {
      ValidationProvider,
      ValidationObserver,
      "confirm-message-modal": confirmMessageModal,
      "success-message-modal": successMessageModal,
      "error-message-modal": errorMessageModal,
    }
    ,
    methods: {
      ...
        mapActions({
          get_tenant: "Push_notifications/get_tenant",
          retrieve_receptors: "Push_notifications/retrieve_receptors",
          retrieve_users: "Push_notifications/retrieve_users",
        }),
      hideConfirmMessageModal() {
        this.showConfirmMessageModal = false;
      },
      closeConfirmMessageModal() {
        this.showConfirmMessageModal = false;
      },
      hideSuccessMessageModal() {
        this.showSuccessMessageModal = false;
      },
      hideErrorModal() {
        this.showErrorModal = false;
      },
      clickConfirmMessageModal() {
        this.showConfirmMessageModal = false;

        this.$store.dispatch("Push_notifications/send_notification").then(response => {
          if (!response) return;
          if (response.status === 'success') {
            // Para no inflar el modal de success, dejamos el summary loggeado.
            // Si más adelante queremos mostrarlo, hay que extender success-message
            // con props (title/body/summary) — ver reporte adjunto.
            this.lastSummary = response.summary;
            if (response.summary) {
              // eslint-disable-next-line no-console
              console.log('[alerts] push summary', response.summary);
            }
            this.showSuccessMessageModal = true;
          } else if (response.status === 'no_devices') {
            this.errorMessage = `None of the ${response.recipients_targeted} selected recipients have a registered device. They need to sign in to the mobile app first.`;
            this.showErrorModal = true;
          } else if (response.status === 'error') {
            this.errorMessage = response.error || 'Failed to send. Try again.';
            this.showErrorModal = true;
          }
        });
      },
      async submit() {
        const self = this;
        self.valid = await
          this.$refs.validator.validate();
        if (self.valid) {
          const index = self.users.findIndex(a => a.owner_id === self.selectedUser);


          await
            this.$store.commit("Push_notifications/save_notification", {
              title: self.title,
              text: self.text,
              vendors: self.vendors,
              agents: self.agents,
              clients: self.clients,
              selected_vendors: self.selected_vendors,
              selected_agents: self.selected_agents,
              selected_clients: self.selected_clients,
              total_contacts: self.total_contacts,
              user: self.users[index]
            });
          self.showConfirmMessageModal = true;
        }
      },
      check_vendors: function () {
        if (this.vendors) {
          for (const obj of this.vendors_list) {
            this.selected_vendors.push(obj.owner_id)
          }
        } else {
          this.selected_vendors = []
        }
        this.calculate_total();
      },
      check_agents: function () {
        if (this.agents) {
          for (const obj of this.agents_list) {
            this.selected_agents.push(obj.owner_id)
          }
        } else {
          this.selected_agents = []
        }
        this.calculate_total();
      },
      check_clients: function () {
        if (this.clients) {
          for (const obj of this.clients_list) {
            if (!this.selected_clients.includes(obj.owner_id) && obj.owner_id !== undefined) {
              this.selected_clients.push(obj.owner_id);
              if (Array.isArray(obj.owner_id)) {
                if (!this.selected_all_clients.includes(obj.owner_id)) {
                  this.selected_all_clients.push(obj.owner_id);
                }
              }
            }

          }
        } else {
          this.selected_all_clients = [];
          this.selected_clients = []
        }
        this.calculate_total();
      },
      check: function () {
        if (this.vendors) {
          this.selected_vendors = [...this.vendors_list]
        }
        if (this.agents) {
          this.selected_agents = [...this.agents_list]
        }
        if (this.clients) {
          this.selected_clients = [...this.clients_list]
        }

        this.calculate_total();
      },
      click_select: function () {
        if (keycode.isEventKey(event, 'backspace')) {
          if (this.selected_all_clients.length > 0) {
            this.selected_all_clients = [];
            this.selected_clients = []
          }
        }

        let selecteds = this.selected_all_clients;
        for (const prop of this.selected_clients) {
          if (Array.isArray(prop)) {
            if (!selecteds.includes(prop)) {
              selecteds.push(prop);
            }
            for (const obj of prop) {
              if (!this.selected_clients.includes(obj)) {
                this.selected_clients.push(obj)
              }
            }
          }
        }
        let items_to_deleted = [];
        for (const prop of selecteds) {
          if (!this.selected_clients.includes(prop)) {
            for (const item of prop) {
              items_to_deleted.push(item);
            }
          }
          if (!this.selected_clients.includes(prop)) {
            this.selected_all_clients.splice(prop);
          }
        }
        let result = this.selected_clients.filter(function (e) {
          return items_to_deleted.indexOf(e) == -1
        });
        this.selected_clients = result;

        if (this.selected_vendors.length !== this.total_vendors) {
          this.vendors = false;
        } else {
          this.vendors = true;
        }

        if (this.selected_agents.length !== this.total_agents) {
          this.agents = false;
        } else {
          this.agents = true;
        }

        if (this.selected_clients.length !== this.total_clients) {
          this.clients = false;
        } else {
          this.clients = true;
        }
        this.calculate_total();
      },
      calculate_total() {
        let count = 0;
        for (const prop of this.selected_clients) {
          if (Array.isArray(prop)) {
            count++;
          }
        }
        let total = this.selected_vendors.length + this.selected_agents.length + this.selected_clients.length;
        if (count > 0) {
          total = total - count;
        }
        this.total_contacts = total;
      },
      returnHeadersAndFilter(item, queryText, itemText) {
        if (item.header) {
          return true
        }
        return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      },
      short_name(name) {
        let res = name.substring(0, 10);
        return res + '...';
      }
    }
  }
  ;
</script>
<style scoped>
  .alert-sidebar {
    max-width: 130px;
    width: 130px;
    background: #29abe2;
    border-radius: 10px 0 0 10px;
  }

  .top-container {
    margin-top: 0px !important;
    padding: 0px !important;
  }

  .custom-container {
    top: 20px;
    max-width: 1222px !important;
    min-height: 557px;
    margin-bottom: 50px !important;
  }

  .table_theme {
    padding: 20px 20px;
  }

  span.preview_iphone {
    width: 180px;
    height: 33px;
    opacity: 0.9;
    color: gray;
    font-size: 17px !important;
    font-style: normal;
    letter-spacing: 0;
    line-height: normal;
    text-align: left;
    top: 40px;
    position: absolute;
    left: 75px;
    font-family: 'Roboto-Bold';
  }

  span.title_push {
    width: 190px;
    height: 33px;
    opacity: 0.9;
    color: #000;
    font-size: 12px !important;
    font-style: normal;
    letter-spacing: 0px;
    line-height: normal;
    text-align: left;
    top: 278px;
    position: absolute;
    left: 52px;
    font-family: 'Roboto-Bold';
  }

  div.text_push {
    width: 190px;
    height: 30px;
    opacity: 0.9;
    color: #000;
    font-size: 12px !important;
    font-weight: normal;
    font-style: normal;
    letter-spacing: 0px;
    line-height: normal;
    text-align: left;
    top: 292px;
    position: absolute;
    left: 52px;
    font-family: "Roboto-Regular"
  }

  .custom-textarea .v-input__control {
    background-color: maroon;
  }

  .title_custom {
    color: #041332 !important;
    font-size: 30px !important;
    font-weight: 500 !important;
    line-height: 34px !important;
    font-family: "Roboto-Medium" !important;
  }

  .push_notification {
    width: 100%;
    max-width: 1255px !important;
    height: auto;
  }

  .alert-field-container {
    width: 715px;
    max-width: 100%;
  }

  .imagen_movil img {
    margin-top: 58px;
    margin-left: 11px;
    width: 254px;
    height: 523px;
  }

  .content_push_notificatin {
    padding: 15px 50px 0 30px;
  }

  .title_text {
    color: #3256a4;
    font-size: 18px;
    font-weight: 400;
  }

  .title_text_one {
    color: #717e91;
    font-size: 14px;
    font-weight: 400;
    line-height: 15px;
    margin-left: 14px;
  }

  .v-select__selections {
    font-size: 6px !important;
  }

  @media screen and (max-width: 1100px) {
    .alert-sidebar,
    .icon-modal-mobile {
      display: none !important;
    }

    .imagen_movil {
      display: none !important;
    }

    .content_push_notificatin {
      padding: 15px 20px 0 20px !important;
      max-width: 100% !important;
      flex: 0 0 100% !important;
    }

    .push_notification {
      width: 100% !important;
      height: auto;
    }

    .alert-field-container {
      width: 100%;
    }
  }

  @media screen and (max-width: 600px) {
    .title_custom {
      font-size: 22px !important;
      line-height: 28px !important;
    }

    .title_text {
      font-size: 13px !important;
    }

    .content_push_notificatin {
      padding: 10px 12px 0 12px !important;

      /* Keep checkboxes and dropdowns in 3-column rows on mobile */
      .d-flex.justify-space-between {
        flex-wrap: nowrap !important;
      }

      .d-flex.justify-space-between > .col-12 {
        flex: 1 1 0 !important;
        max-width: 33.33% !important;
        padding: 0 4px !important;
      }

      .checkbox_options {
        margin-top: 0 !important;
        padding-top: 0 !important;
      }
    }

    .custom-container {
      padding: 10px 8px !important;
      top: 10px !important;
    }

    .table_theme {
      padding: 10px 4px !important;
    }

    .buttons-option .btn-azul {
      left: 0 !important;
      width: 100% !important;
      max-width: 280px;
    }
  }
</style>
